/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-apps': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M5 2.5V5H2.5V2.5H5zm1.25-1.25h-5v5h5v-5zm5 1.25V5h-2.5V2.5h2.5zm1.25-1.25h-5v5h5v-5zm5 1.25V5H15V2.5h2.5zm1.25-1.25h-5v5h5v-5zM5 8.75v2.5H2.5v-2.5H5zM6.25 7.5h-5v5h5v-5zm5 1.25v2.5h-2.5v-2.5h2.5zM12.5 7.5h-5v5h5v-5zm5 1.25v2.5H15v-2.5h2.5zm1.25-1.25h-5v5h5v-5zM5 15v2.5H2.5V15H5zm1.25-1.25h-5v5h5v-5zm5 1.25v2.5h-2.5V15h2.5zm1.25-1.25h-5v5h5v-5zm5 1.25v2.5H15V15h2.5zm1.25-1.25h-5v5h5v-5z"/>'
  }
})
